import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  IconButton,
  Typography,
  useClickOutside
} from '@destination/components';

import MeatballIcon from '@icons/three_dots_16.svg?react';

export type IMenuItem = {
  label: string;
  onClick: () => void;
};

export interface IMenuButton {
  options: IMenuItem[];
  isLoading?: boolean;
}

const MenuButton = ({ options }: IMenuButton) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const filterRef = useRef<HTMLDivElement>(null);

  const { t } = useTranslation(undefined, {
    keyPrefix: 'browse.options_button'
  });

  useClickOutside(filterRef, () => setIsExpanded(false));

  const containerBaseClasses =
    'absolute mt-1 flex  rounded bg-white !p-2 shadow-[0_0_15px_rgba(0,0,0,0.2)] w-auto';

  return (
    <div ref={filterRef}>
      <IconButton
        data-testid="meatball-menu-icon"
        onClick={() => setIsExpanded(prevState => !prevState)}
      >
        <MeatballIcon />
      </IconButton>
      {isExpanded && (
        <ul
          className={`${containerBaseClasses} z-[1000] mt-1 max-h-[292px] w-full max-w-[200px] flex-col gap-0.5 overflow-y-auto ml-[-160px]`}
          data-testid="options-menu"
        >
          {options.map(option => {
            return (
              <li
                data-testid={option.label}
                key={option.label}
                className={`cursor-pointer rounded px-[4px] py-[5px] hover:bg-[#F5F5F5] hover:font-bold`}
                onClick={option.onClick}
              >
                <Typography variant="smallText">{t(option.label)}</Typography>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default MenuButton;
